// extracted by mini-css-extract-plugin
export default {"switch":"ToggleOverrides__switch___qAwz7"};